import { useContent } from '@/lib/content-context'
import { Button } from '@/ui'
import { useTranslation } from '@/i18n'

export function Contact() {
  const { links } = useContent()
  const { t } = useTranslation()

  return (
    <section id="contact" className="py-12 bg-blue-50 dark:bg-blue-950/20">
      <div className="max-w-3xl mx-auto text-center px-4">
        <h2 className="text-3xl font-bold mb-4 dark:text-gray-100">{t('contact.title')}</h2>
        <p className="text-gray-700 mb-6 dark:text-gray-300">{t('contact.description')}</p>
        <div className="flex gap-4 justify-center">
          <Button variant="primary" size="lg" href={`mailto:${links.email}`}>
            {t('contact.sendEmail')}
          </Button>
          <Button variant="outline" size="lg" href={links.linkedin}>
            {t('contact.linkedin')}
          </Button>
          <Button variant="outline" size="lg" href={links.github}>
            {t('contact.github')}
          </Button>
        </div>
      </div>
    </section>
  )
}
